import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import About from './components/About';
import Error from './components/Error';

import Body from './components/Body';
import Contact from './components/Contact';
import RestaurantMenu from './components/RestaurantMenu';
//import Profile from './components/Profile';
import GitProfile from "./components/GitProfile";
import YourComponent from "./components/Shimmer";
// import Instamart from './components/Instamart';
import Cart from './components/Cart';
import Register from './components/Register';

/*
const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
    errorElement: <Error/>
  },
  {
    path: "/About",
    element: <About/>
  }
]);
*/

// chunking or bundling
const Instamart = lazy(() => import("./components/Register"));

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <Error />,
    children: [
      {
        path: "/",
        element: <Body />
      },
      {
        path: "/About",
        element: <About />,
        children: [
          {
            path: "Profile",
            // element: <Profile/>,
            element: <GitProfile />
          },
        ],
      },
      {
        path: "/contact",
        element: <Contact />
      },
      {
        path: "/cart",
        element: <Cart/>
      },
      {
        path: "/restaurant/:id",
        element: <RestaurantMenu />
      },
      {
        path: "/restaurant/",
        element: <RestaurantMenu />
      },
      {
        path: "/register/",
        element: (
          <Suspense fallback={<YourComponent/>}>
            <Instamart />
          </Suspense>
        ),
      },
      
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={appRouter} />
);

reportWebVitals();
